export const CONTACT_CONFIG = {
  phoneNumber: "+44 7478 067087",
  
  email: "contact@tivi-one1.com",

  whatsappUrl: "https://wa.me/447478067087",

  companyName: "TiviOne",

  websiteUrl: "https://tivi-one1.com"
};

export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
